import type { Sport } from '__generated__/globalTypes';

import type { ConversionCreditWithAmounts } from './useConversionCredits';
import { useConversionCredits } from './useConversionCredits';

export const useConversionCredit = (
  sport?: Sport
): ConversionCreditWithAmounts | undefined => {
  const { conversionCredits } = useConversionCredits({
    sport,
  });

  return conversionCredits?.[0];
};
